import { render, staticRenderFns } from "./TagActionDelete.vue?vue&type=template&id=38096c08&"
import script from "./TagActionDelete.vue?vue&type=script&lang=ts&"
export * from "./TagActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports